import { useTranslation } from 'react-i18next';

export default function ServicesQuartier() {
  const { t } = useTranslation('stjean');

  const services = [
    { icon: 'ri-hammer-line', label: t('service_1') },
    { icon: 'ri-arrow-left-right-line', label: t('service_2') },
    { icon: 'ri-history-line', label: t('service_3') },
    { icon: 'ri-drop-line', label: t('service_4') },
    { icon: 'ri-file-search-line', label: t('service_5') },
    { icon: 'ri-snowy-line', label: t('service_6') },
  ];

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-8 md:mb-10 text-center">
          {t('services_h2')}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {services.map((s, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 p-5 md:p-6 rounded-lg bg-white border border-gray-100 hover:border-[#C77D3F]/30 hover:shadow-sm transition-all"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-md bg-[#C77D3F]/10 text-[#C77D3F]">
                <i className={s.icon} />
              </div>
              <span className="text-sm md:text-base font-medium text-[#1B2A4E] leading-snug pt-1">
                {s.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}